import notification_all from './notification_all';
import notification_all_not_seen from './notification_all_not_seen';
import notification_mark_all_seen from './notification_mark_all_seen';

export const NOTIFICATIONS = {
  notification_all: notification_all,
  notification_all_not_seen: notification_all_not_seen,
  notification_mark_all_seen: notification_mark_all_seen,
};
